import React, { useState } from 'react';

import { useDebouncedValue } from '@mantine/hooks';

import MissingAthletesPageHeader from './components/MissingAthletesPageHeader';
import MissingAthletesTable from './components/MissingAthletesTable';

interface FilterTerms {
  athleteStatuses: string[];
  packages: string[];
}

const MissingAthletes = (): JSX.Element => {
  const initialSearchFiltersValue = {
    athleteStatuses: [],
    packages: [],
  };

  const [orderingValue, setOrderingValue] = useState<string>('lastCheckInDate');
  const [searchFilters, setSearchFilters] = useState<FilterTerms>(initialSearchFiltersValue);
  const [debouncedSearchFilters] = useDebouncedValue<FilterTerms>(searchFilters, 250);

  return (
    <>
      <MissingAthletesPageHeader
        orderingValue={orderingValue}
        searchFilters={searchFilters}
        setSearchFilters={setSearchFilters}
      />

      <MissingAthletesTable searchFilters={debouncedSearchFilters} setOrderingValue={setOrderingValue} />
    </>
  );
};

export default MissingAthletes;
